define('mustache-language/translator',['require','exports','module','./lib/Translator'],function(require,exports,module){
    var Translator = require( "./lib/Translator" );

    var translators = {};

    /**
     * Create a Translator instance for the requested language.
     * This can be used directly if a lambda-wrapped function is not desired.
     * @example
     *     var translator = translatorFactory('es');
     *     // es dictonary =>  { "{{1}} words in english" : "{{1}} palabras en Inglés"}
     *     translator.translate("{{count}} words in english") => "{{count}} words in english"
     * @param  {string} lang Selected language from the set of dictionaries to be used
     *                       for translation.
     * @return {object}      Translator instance
     */
    return function(lang,decode){
        decode = decode===true;
        var ckey = lang + decode;
        return translators[ckey] || (translators[ckey] = new Translator(lang, decode));
    }

});

